import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {FixDates} from "../_decorators/date.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ActionItemService {
    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }
  @Load()
  saveActionItem(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/actionPlanTemplates', result);
  }
  @Load()
  setActionItemOrder(order: number[]) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/actionPlanTemplates/order', order);
  }
  @Load()
  saveActionItemSet(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/actionPlanTemplateSets', result);
  }
  @Load()
  deleteActionItemSet(id: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete<any>(this.config.api + '/api/actionPlanTemplateSets/' + id);
  }
  @FixDates()
  getAllActionItemTemplateSets() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/actionPlanTemplateSets');
  }
  @FixDates()
  getAllActionItemsFull() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/actionPlanTemplates/full');
  }
  @FixDates()
  getActionItemsForProject(projectId: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/actionPlanTemplates/project/' + projectId);
  }
  @FixDates()
  getAllPolicys() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/actionPlanTemplates');
  }
  @FixDates()
  getActionItem(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/actionPlanTemplates/' + id);
  }

  @Load()
  deleteActionItem(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/actionPlanTemplates/' + id);
  }

  @Load()
  deleteActionItems(ids) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post(this.config.api + '/api/actionPlanTemplates/multiple', ids);
  }

  @Load()
  uploadItems(entity: File, id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/actionPlanTemplates/upload/' + id, formData)
      ;
  }
}
